// TODO: Should we just inlude _underscore? => much safer and no need to check algorithms

/**
 * Helper functions arrays.js
 *
 * @namespace arrays
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/helper/arrays.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

/**
 * removes doubles and returns unique values inside the array
 * @function arrays.uniqueValues
 * @param arr
 * @return {*}
 */
export const uniqueValues = (arr) => arr.filter(onlyUnique);

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

/**
 * Checks if all values are equal inside an array
 * @function arrays.sameUniqueValues
 * @param arr
 * @return {*}
 */
export const sameUniqueValues = (arr) => uniqueValues(arr).length === 1;

/**
 * Checks if an array contains only unique values
 * @function arrays.isDistinct
 * @param arr
 * @returns {boolean}
 */
export const isDistinct = (arr) => arr.length === uniqueValues(arr).length;

/**
 * Checks if 2 simple arrays are the same.
 * @function arrays.isEqual
 * @param arr1
 * @param arr2
 * @returns {boolean}
 */
export const isEqual = (arr1, arr2) => {
    return arr1.length === arr1.length && arr1.every(function (element, index) {
        return element === arr2[index];
    });
}
/**
 * @function arrays.difference
 */
export const difference = (arr, arrToRemove) => arr.filter((el) => !arrToRemove.includes(el));
/**
 *
 * @function arrays.pageArrayResults
 * @param array
 * @param pageSize
 * @return {array}
 */
export const pageArrayResults = (array, pageSize) => {
    const result = []

    array.forEach((questionnaire, index) => {
        let page

        if (index % pageSize === 0) {
            page = []
            result.push(page)
        } else {
            page = result[result.length - 1]
        }

        page.push(questionnaire)
    })

    return result
}

/**
 * groups array of objects by key
 * @function arrays.groupBy
 */
export const groupBy = (objectArray, property) => {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}